export const CHAT_REF = 'chat/participants';

export default function (_this) {
  return {
    add (participant) {
      return getRef().push(participant);
    },
    getAll (cb) {
      return new Promise((resolve) => {
        getRef().once('value', (snapshot) => {
          const participants = [];
          const map = snapshot.val() || {};
          for (let key in map) {
            participants.push({
              id: key,
              ...map[key]
            });
          }
          cb(participants);
          resolve();
        });
      });
    },
    deleteAll() {
      return getRef().remove()
    },
    delete (id) {
      return new Promise((resolve) => {
        getRef()
          .child(id)
          .remove((err) => {
            resolve(err)
          });
      });
    },
    getRef
  }

  function getRef() {
    return _this.getRef(CHAT_REF);
  }
}
